import React, {PureComponent,Fragment} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import AppsView from './AppsView';
import DownloadApp from 'components/DownloadApp';
import Loader from 'components/Loader';

import {fetchApps,uninstallApp,openConfig,closeConfig,saveSettings,doReset,getAuthUrl,installApp,saveInstallAppDetailsUntilLogin,clearInstallAppDetails,toggleFormModal,migrateApp} from 'actions';
import WithNotifications from 'containers/WithNotifications';
import './apps.css';
import {getBrand} from '../../utils';

class Apps extends PureComponent{
    constructor(props){
        super(props);
        this.state={
            showInstalled:false,
            tags:[],
            search:'',
            category:'All'
        }
    }
    componentDidMount(){
        this.props.fetchApps(this.props.authenticated)
        .then(()=>{
            document.title = `${this.renderBrandName()} Integrations`;
            if(this.props.urlSearchTerm){
                this.setState({search:this.props.urlSearchTerm});
            }
            if(this.props.appIDToInstall && !this.props.requireApiKey){
                !this.appAlreadyInstalled() ? this.props.getAuthUrl(this.getAuthenticatedApp()) : this.props.clearInstallAppDetails();
            }
            if(this.props.appIDToInstall && this.props.requireApiKey){
                !this.appAlreadyInstalled() ? this.props.toggleFormModal(this.getAuthenticatedApp().ID,'install') : this.props.clearInstallAppDetails();
            }
            if(this.props.intent){
                const intentApp = this.props.apps.find(app => app.source === this.props.intent.app);
                const appAlreadyInstalled = intentApp && intentApp.appInstallationID ? true : false;
                const userLoggedIn = this.props.authenticated;
                const installRequiresApiKey = intentApp && intentApp.oAuthVersion === 'apiKey' ? true : false;
                if(this.props.intent.action === 'install'){
                    if(userLoggedIn){
                        if(intentApp.link) return window.location.href = intentApp.link;
                        if(!appAlreadyInstalled) return installRequiresApiKey ? this.props.toggleFormModal(intentApp.ID, 'install') : this.props.getAuthUrl(intentApp);
                        //if(appAlreadyInstalled) return installRequiresApiKey ? this.props.toggleFormModal(intentApp.ID, 'currentlyInstalled') : null;
                        return;
                    }
                    return this.props.history.push('/');
                }
                if(this.props.intent.action === 'configure'){
                    if(userLoggedIn) return appAlreadyInstalled ? this.props.toggleFormModal(intentApp.ID, 'configure') : null;
                    return this.props.history.push('/');
                }
                if(this.props.intent.action === 'delete'){
                    if(userLoggedIn) return appAlreadyInstalled ? this.onUninstallApp(intentApp.appInstallationID,intentApp.ID) : null;
                    return this.props.history.push('/');
                }
            }
        })
    }
    getAuthenticatedApp=()=>{
        return this.props.apps.find(app => app.ID === this.props.appIDToInstall);
    }
    appAlreadyInstalled=()=>{
        const appToCheck = this.props.apps.find(app =>app.ID === this.props.appIDToInstall);
        return appToCheck ? appToCheck.appInstallationID : false;
    }
    onInstallApp=(app)=>{
        return this.props.authenticated ? this.props.getAuthUrl(app) : this.onSaveInstallAppDetailsUntilLogin(app.ID);
    }
    onSaveInstallAppDetailsUntilLogin=(ID,apiKey)=>{
        this.props.saveInstallAppDetailsUntilLogin(ID,apiKey);
        this.props.history.push('/');
    }
    onResetApp=(app)=>{
        if(app.migrateTo){
            this.props.migrateApp(app)
            .catch(() => this.props.addNotification('error', 'There was a problem migrating the integration'));
        }
        if(app.oAuthVersion === 'apiKey'){
            this.props.uninstallApp(app.appInstallationID, 'resetApp')
            .then(() => this.props.toggleFormModal(app.ID, 'install'))
            .catch(() => this.props.addNotification('error', 'There was a problem resetting the integration'));
        }
        else this.props.doReset(app);
    }
    onUninstallApp=(appID,ID)=>{
        this.props.uninstallApp(appID)
        .then(()=>{
            const app = this.props.apps.find(app => app.ID === ID)
            this.props.addNotification('success',`${app ? app.name : 'App'} uninstalled successfully`)
        })
        .catch(err=>this.props.addNotification('error',"There was a problem uninstalling the integration"))
    }
    renderBrandName(){
        return getBrand() === 'circleloop' ? 'CircleLoop' : 'CloudTalk';
    }
    renderApps(app){
        return this.props.displayPreviewApps || this.props.fromPreviewQuery ? app.brand === getBrand() : app.brand === getBrand() && !app.preview;
    }
    getTagNames(){
        const tags = this.props.apps.filter(app=>app.brand===getBrand()).map(app=>app.tags).reduce((a,b)=>{return a.concat(b)},[]).reduce((a,b)=>{
            if(a.indexOf(b)<0) a.push(b);
            return a;
        },[]).filter(e=>e).sort().map(tag=>{return {name:tag,selected:false}});
        return [{name:'All',selected:true}].concat(tags);
    }
    orderApps(apps){
        const featuredApp = apps.filter(app=>app.hasOwnProperty('featured'));
        const appsWithOrderKey = apps.filter(app=>app.hasOwnProperty('order') && !app.hasOwnProperty('featured')).sort((a,b)=>a.order-b.order);
        const otherApps = apps.filter(app=>!app.hasOwnProperty('order') && !app.hasOwnProperty('featured')).sort((a,b)=>(a.source>b.source) ? 1 : ((b.source>a.source) ? -1 : 0));
        return featuredApp.concat(appsWithOrderKey,otherApps);
    }
    filterApps(){
        const {apps} = this.props;
        const {search,showInstalled,category} = this.state;
        return this.orderApps(apps.filter(app=>{
            const appInstalled = showInstalled ? app.appInstallationID : app;
            const hasCategory = category==='All' ? true : app.tags.indexOf(category) > -1;
            const hasSearch = new RegExp(`^(?:DEV - )?${search}`,'i').test(app.name) || new RegExp(search,'i').test(app.source);
            return appInstalled && hasCategory && hasSearch && this.renderApps(app);
        }))
    }
    onToggleInstalled=()=>{
        this.setState({showInstalled:!this.state.showInstalled});
    }
    onFilterByTag=(tag)=>{
        const {tags} = this.state;
        const index = tags.indexOf(tag);
        this.setState({tags:index >= 0 ? tags.filter(t=>t!==tag) : tags.concat(tag)});
    }
    onSearch=(ev)=>{
        ev.preventDefault();
        this.setState({search:ev.target.value});
    }
    onClearSearch=()=>{
        this.setState({search:''});
    }
    hasIntegrationErrors(){
        const {apps} = this.props;
        return apps.filter(app=>app.tokenInvalid).length > 0 ? true : false;
    }
    onSelectCategory=(tag)=>{
        this.setState({category:tag});
    }
    render(){
        return this.props.loaded && this.props.apps ?
            <Fragment>
                <AppsView 
                    apps={this.filterApps()}
                    tags={this.getTagNames()}
                    category={this.state.category}
                    onSelectCategory={this.onSelectCategory}
                    onToggleInstalled={this.onToggleInstalled}
                    onFilterByTag={this.onFilterByTag}
                    showInstalled={this.state.showInstalled}
                    hasIntegrationErrors={this.hasIntegrationErrors()}
                    onSearch={this.onSearch}
                    search={this.state.search}
                    onInstallApp={this.onInstallApp}
                    onUninstallApp={this.onUninstallApp}
                    onResetApp={this.onResetApp}
                    onClearSearch={this.onClearSearch}
                    app={this.state.app}
                    authenticated={this.props.authenticated}
                    integrations={this.props.integrations}/>
                {getBrand() === 'circleloop' ? <DownloadApp authFromMobile={this.props.mobile}/> : null}
            </Fragment>
        : <Loader/>
    }
}

Apps.contextTypes = {
    router:PropTypes.object
}

function mapStateToProps(state){
    return {
        apps:state.apps,
        mobile:state.auth.mobile,
        displayPreviewApps:state.previewApps.displayPreviewApps,
        fromPreviewQuery:state.previewApps.fromPreviewQuery,
        loaded:state.auth.loaded,
        urlSearchTerm:state.user.urlSearchTerm,
        intent:{action:state.user.intentAction,app:state.user.intentApp},
        authenticated:state.auth.authenticated,
        integrations:state.integrations,
        appIDToInstall:state.previewApps && state.previewApps.appIDToInstall,
        requireApiKey:state.previewApps && state.previewApps.requireApiKey,
    }
}

export default WithNotifications(connect(mapStateToProps,{fetchApps,doReset,uninstallApp,openConfig,closeConfig,saveSettings,getAuthUrl,installApp,saveInstallAppDetailsUntilLogin,clearInstallAppDetails,toggleFormModal,migrateApp})(Apps))


// WEBPACK FOOTER //
// ./src/scenes/Apps/index.js